const errors = {
    missingAnalyticsPackage: '[Analytics Public DPS Service]: Missing peerDependency @octagon/analytics',
    serviceDisabled: '[Analytics Public DPS Service]: Disabled, check the `env` option in configuration settings',
};
export default errors;
//# sourceMappingURL=errors.js.map